import { useRef, useState } from 'react'
import { useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { Icon } from '../../../../../../common/html/icon'
import DropdownTooltip from '../../../../../../common/textEllipsis/DropdownTooltip'
import { FORMAT, formatDateTime } from '../../../../../../helpers/datetime'

export const ScoreTooltip = ({ publicDate }) => {
  const ref = useRef()
  const [isShow, setIsShow] = useState(false)

  const locale = useSelector((state) => state.i18n.locale)
  const month = formatDateTime(publicDate, FORMAT.MONTH)

  const onMouseEnter = () => {
    setIsShow(true)
  }

  const onMouseLeave = () => {
    setIsShow(false)
  }

  return (
    month >= 1 &&
    month <= 11 && (
      <>
        <Icon
          iconRef={ref}
          onMouseEnter={onMouseEnter}
          onMouseLeave={onMouseLeave}
          className="icon-info-circle"
          style={{
            fontSize: 10,
            paddingLeft: 5,
            cursor: 'default',
          }}
        />
        {isShow && (
          <DropdownTooltip
            containerRef={ref}
            text={
              <Translate
                value="companyAnalysis.peerAnalysis.LAST_PUBLIC_DATE"
                publicDate={formatDateTime(publicDate, FORMAT.DATE, locale)}
              />
            }
            isI18n={false}
            isOpenTooltip={isShow}
            zIndexTooltip={1}
            tooltipMaxWidthByContent={false}
            childStyle={{ fontSize: 10 }}
          />
        )}
      </>
    )
  )
}
